/*eslint-disable */

import axios from 'axios';
import {
  bus
} from '../../../main';
import countries from '../../../services/country.json'
import {
  mapGetters
} from 'vuex';
import toast from '../../../services/toast';

const $ = window.jQuery = require('jquery');




export default {
  name: 'chat-request-user-list',
  components: {},
  props: [],
  data () {
    return {
      chatRequestList:null,
      chatRequestListResults:[],
      checkDataTaskModal:false,
      chatRequestId:'',
      chatRequestConfirmId:'',
      chatRequestUserList:'',
      blockedUserId:'',
      confirmUserId:'',
      roomChatId:'',
      dataRemoveLoader:false,
      countryList:[],
    }
  },
  computed: {
  ...mapGetters([
    'chatConnectionRequestListGetters'
  ]),
  getUserConnectionReqListFun(){
    return this.chatRequestList = this.$store.getters.chatConnectionRequestListGetters.data
  },
  setInitialStates(){
    if(this.chatRequestList){
      this.chatRequestListResults = this.chatRequestList.data
    }
  }
  },
  mounted () {
    bus.$emit('userFriendRequestClear', {});
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.getUserConnectionReqListFun
    this.setInitialStates
  },
  methods: {
    getNormalUserListAgain(){
      this.$store.dispatch('chatConnectionRequestListFun').then((res) =>{
        this.chatRequestUserList = res.data.data
      }).catch((err) => {

      })
    },
    approveChatRequestFun(ApporvedUserId, blockedUserId, confirmUserId){
      this.chatRequestId = ApporvedUserId
      this.blockedUserId = blockedUserId
      this.confirmUserId = confirmUserId
      this.checkDataTaskModal = true
    },
    ApporveChatRequestConfirmFun(){
      this.submitted = true
      let data = {
        is_approved:true
      }
      this.$store.dispatch('apporvedConnectionRequestFun', {data:{id:this.chatRequestId, data:data}}).then((res) =>{
        toast.success(res.data.msg);
        this.submitted = false
        this.getNormalUserListAgain()
        this.closedApproveChatRequestFun()
        // this.$store.dispatch('chatBroserNotificationFun')
      }).catch((error) => {
        this.submitted = false
        toast.error(error.data.data.non_field_errors || error.data.msg)

      })
    },
    unApproveChatRequestFun(id){
      this.submitted = true
      this.dataRemoveLoader = true
      let data = {
        is_approved:false
      }
      this.$store.dispatch('apporvedConnectionRequestFun', {data:{id:id, data:data}}).then((res) =>{
        toast.success(res.data.msg);
        this.getNormalUserListAgain()
        this.submitted = false
        this.dataRemoveLoader = false
      }).catch((err)=>{
        this.submitted = false
        this.dataRemoveLoader = false
        toast.error(err.data.data.non_field_errors || err.data.msg);
      })

    },
    confirmBlockedUser(){
      let data = {
        blocked_user : this.blockedUserId
      }
      this.$store.dispatch('createBlockUserFun', data )
      .then((res) => {
        toast.success(res.data.msg);
        this.blockedUserId = ''
        this.checkDataTaskModal = false
        this.getNormalUserListAgain()
      }).catch((err) => {
        toast.error(err.data.data.non_field_errors || err.data.msg);
      })
    },
    closedApproveChatRequestFun(){
      this.chatRequestId = ''
      this.blockedUserId = ''
      this.checkDataTaskModal = false
      this.chatRequestUserList  = ''
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
    getUserConnectionReqListFun(){
      return this.$store.getters.chatConnectionRequestListGetters;
    },
    setInitialStates(){
      if(this.chatRequestList){
        this.chatRequestListResults = this.chatRequestList.data
      }
    }
  }
}
